import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button, Spinner, Badge } from "react-bootstrap";
import Sample14 from "../Components/Logo";
import { useAuth } from "../Context/AuthContext";
import { fetchCompnayCodesById } from "../Api/InvoiceApi";
import { Base_URL } from "../url";
import { toast } from "react-toastify";
// NOTE: Replace `getAssets` with your real API call. Example:
// import { getAssets } from '../Api/AssetApi';
import axios from "axios";
const emptyStation = () => ({
  stationType: "",
  executionType: "",
  productionStationDescription: "", // <-- NEW field
  electricityUtilization: "",
  electricityUnit: "KW",
  capacity: "",
  capacityUnit: "L",
  assetId: "", // single asset per station (dropdown)
});

const ProductionStationConfigScreen = () => {
  const { user } = useAuth();
  const orgId = user?.organisationId;

  const [loading, setLoading] = useState(false);
  const [dropdownLoading, setDropdownLoading] = useState(false);
  const [assets, setAssets] = useState([]);
  const [companyCodes, setCompanyCodes] = useState([]);
  const [companyCode, setCompanyCode] = useState("");
  const [stationType,setStationType]=useState([]);
  // multiple stations
  const [stations, setStations] = useState([emptyStation()]);
 const[eType,setEType]=useState([]);
  const STATION_TYPES = ["EQP", "LIN", "MAC","MAN"];
  const EXECUTION_TYPES = [
    "AEL",
    "MAN",
    "MLE",
  ];

  const ELECTRICITY_UNITS = ["KW", "W", "HP"];
  const CAPACITY_UNITS = ["L", "m3", "kg", "units"];

  useEffect(() => {
    const fetchDropdowns = async () => {
      setDropdownLoading(true);
      try {
        // fetch company codes
        const companies = await fetchCompnayCodesById(orgId);
        setCompanyCodes(companies || []);

        // set first company code as default if available
        if (companies && companies.length > 0) {
          const first = companies[0];
          const code = first.companyCode ?? first.code ?? first.value ?? first.id ?? first.CompanyCode;
          setCompanyCode(String(code));
        }

        // TODO: replace with your real API call for assets. Example:
        const res = await axios.get(`${Base_URL}/Asset`);
        const res1=await axios.get(`${Base_URL}/ProductionStation/getStationType`)
        const res2=await axios.get(`${Base_URL}/ProductionStation/getExecutionType`)
        // Mock data for now (keep assets load separate so companyCode loads quickly)
        await new Promise((r) => setTimeout(r, 250));
        setAssets(res.data);
        setStationType(res1.data);
        setEType(res2.data);
        // setAssets([
        //   { id: "A01", label: "AUTOMATIC FOUR HEAD VOLUMETRIC LIQUID MACHINE" },
        //   { id: "A02", label: "AUTOMATIC SINGLE HEAD SCREW CAPPING MACHINE" },
        //   { id: "A03", label: "AUTOMATIC ROUND STICKER LABELLING MACHINE" },
        //   { id: "A04", label: "AUTOMATIC SINGLE HEAD SERVO AUGER FILLER MACHINE" },
        // ]);
      } catch (err) {
        console.error("Error fetching dropdowns", err);
      } finally {
        setDropdownLoading(false);
      }
    };

    fetchDropdowns();
  }, [orgId]);

  const handleStationChange = (index, e) => {
    const { name, value } = e.target;
    setStations((prev) => {
      const copy = [...prev];
      copy[index] = { ...copy[index], [name]: value };
      return copy;
    });
  };

  const addStation = () => {
    setStations((p) => [...p, emptyStation()]);
  };

  const removeStation = (index) => {
    setStations((p) => p.filter((_, i) => i !== index));
  };

  const validateAll = () => {
    if (!companyCode) return "Select Company Code";
    if (!stations || stations.length === 0) return "No stations to save";
    for (let i = 0; i < stations.length; i++) {
      const s = stations[i];
      if (!s.stationType) return `Station ${i + 1}: Select Station Type`;
      if (!s.executionType) return `Station ${i + 1}: Select Execution Type`;
      if (s.electricityUtilization === "") return `Station ${i + 1}: Enter electricity utilization`;
      if (!s.electricityUnit) return `Station ${i + 1}: Select electricity unit`;
      if (s.capacity === "") return `Station ${i + 1}: Enter capacity`;
      if (!s.capacityUnit) return `Station ${i + 1}: Select capacity unit`;
      if (!s.assetId) return `Station ${i + 1}: Select an Asset`;
    }
    return null;
  };
  console.log(companyCodes)
  const handleSubmit = async (e) => {
    e.preventDefault();
    const err = validateAll();
    if (err) {
      alert(err);
      return;
    }

    setLoading(true);
    try {
      const payload = {
        orgId,
        companyCode: Number(companyCode),
        createdBy: user?.organisationId ?? null,
        stations: stations.map((s) => ({
          stationType: s.stationType,
          executionType: s.executionType,
          productionStationDescription: s.productionStationDescription, // <-- include in payload
          electricityUtilization: Number(s.electricityUtilization),
          electricityUnit: s.electricityUnit,
          capacity: Number(s.capacity),
          capacityUnit: s.capacityUnit,
          assetId: s.assetId,
        })),
      };

      // send to backend
      const res = await fetch(`${Base_URL}/ProductionStation`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if(res.ok)
      toast.success("Saved successfully");

      // reset after successful save
      setStations([emptyStation()]);

    } catch (err) {
      console.error(err);
      toast.error("Error Adding Station")
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-content expand">
      <Container fluid className="fields-container">
        <h3 className="fields-title">Station Configuration</h3>

        <Form onSubmit={handleSubmit} className="fields-form">
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Company Code</Form.Label>
                <Form.Control
                  as="select"
                  name="companyCode"
                  value={companyCode}
                  onChange={(e) => setCompanyCode(e.target.value)}
                  disabled={dropdownLoading}
                >
                  <option value="">Select Company Code</option>
                  {companyCodes.map((c, i) => {
                    const val = c.companyCode ?? c.code ?? c.value ?? c.id ?? c.CompanyCode;
                    const label = c.name ?? c.companyName ?? c.label ?? String(val);
                    return (
                      <option key={i} value={String(val)}>{val}-{label}</option>
                    );
                  })}
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>

          {stations.map((station, idx) => (
            <div key={idx} className="border rounded p-3 mb-3">
              <Row className="align-items-end">
                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Station Type</Form.Label>
                    <Form.Control
                      as="select"
                      name="stationType"
                      value={station.stationType}
                      onChange={(e) => handleStationChange(idx, e)}
                    >
                      <option value="">Select Station Type</option>
                      {stationType.map((s) => (
                        <option key={s.productionStationType1} value={s.productionStationType1}>{s.productionStationType1}-{s.productionStationDesc}</option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Execution Type</Form.Label>
                    <Form.Control
                      as="select"
                      name="executionType"
                      value={station.executionType}
                      onChange={(e) => handleStationChange(idx, e)}
                    >
                      <option value="">Select Execution Type</option>
                      {eType.map((e) => (
                        <option key={e.productionExecutionType1} value={e.productionExecutionType1}>{e.productionExecutionType1}-{e.productionExecutionDesc}</option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Asset</Form.Label>
                    <Form.Control
                      as="select"
                      name="assetId"
                      value={station.assetId}
                      onChange={(e) => handleStationChange(idx, e)}
                      disabled={dropdownLoading}
                    >
                      <option value="">Select Asset</option>
                      {assets.map((a) => (
                        <option key={a.assetId} value={a.assetId}>{a.assetId}-{a.assetName}</option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>

                <Col md={2} className="text-end">
                  {stations.length > 1 && (
                    <Button variant="danger" onClick={() => removeStation(idx)}>
                      Remove
                    </Button>
                  )}
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Production Station Description</Form.Label>
                    <Form.Control
                      type="text"
                      name="productionStationDescription"
                      value={station.productionStationDescription}
                      onChange={(e) => handleStationChange(idx, e)}
                      placeholder="Enter description"
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Electricity Utilization</Form.Label>
                    <Form.Control
                      type="number"
                      step="any"
                      name="electricityUtilization"
                      value={station.electricityUtilization}
                      onChange={(e) => handleStationChange(idx, e)}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Electricity Unit</Form.Label>
                    <Form.Control
                      as="select"
                      name="electricityUnit"
                      value={station.electricityUnit}
                      onChange={(e) => handleStationChange(idx, e)}
                    >
                      {ELECTRICITY_UNITS.map((u) => (
                        <option key={u} value={u}>{u}</option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Capacity</Form.Label>
                    <Form.Control
                      type="number"
                      step="any"
                      name="capacity"
                      value={station.capacity}
                      onChange={(e) => handleStationChange(idx, e)}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Capacity Unit</Form.Label>
                    <Form.Control
                      as="select"
                      name="capacityUnit"
                      value={station.capacityUnit}
                      onChange={(e) => handleStationChange(idx, e)}
                    >
                      {CAPACITY_UNITS.map((u) => (
                        <option key={u} value={u}>{u}</option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>
            </div>
          ))}

          <div className="d-flex gap-2 mb-3">
            <Button type="button" onClick={addStation}>+ Add Station</Button>
            <Button variant="outline-secondary" type="button" onClick={() => setStations([emptyStation()])}>
              Reset All
            </Button>
          </div>

          <div className="d-flex gap-2 mt-3">
            <Button type="submit" disabled={loading || dropdownLoading}>
              {loading ? (
                <><Spinner animation="border" size="sm" /> Saving...</>
              ) : (
                "Save Stations"
              )}
            </Button>

            <Button variant="secondary" type="button" onClick={() => {
              setStations([emptyStation()]);
            }}>
              Clear
            </Button>
          </div>
        </Form>
      </Container>

      {(loading || dropdownLoading) && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </div>
  );
};

export default ProductionStationConfigScreen
